export default __webpack_public_path__ + "static/media/thumbnail.0f0af2d7.png";